module.exports = __webpack_public_path__ + "media/images/icons/launch_icon-e56cc37094526b6e88feff38ee578e9b.svg";